import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { PRIMARY } from '../components/LmsSectionCard';
import NewsHighlights from './components/NewsHighlights';
import TrainingPerformance from './components/TrainingPerformance';
import TrainingCalendar from './components/TrainingCalendar';
import UpcomingTrainings from './components/UpcomingTrainings';
import RequestedTrainingsCard from './components/RequestedTrainingsCard';
import QuickActions from './components/QuickActions';
import useLmsDashboardStats from './hooks/useLmsDashboardStats';
import useLmsDashboardCalendar from './hooks/useLmsDashboardCalendar';
import useLmsUpcomingTrainings from './hooks/useLmsUpcomingTrainings';
import useLmsDashboardHighlights from './hooks/useLmsDashboardHighlights';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS } from '../../../constants/permissionCodes';
import './lmsDashboard.scss';

const LmsDashboardPage = () => {
    const { th } = useLanguage();
    const statsData = useLmsDashboardStats();
    const calendarData = useLmsDashboardCalendar();
    const upcomingData = useLmsUpcomingTrainings();
    const { can } = useLmsPermission();
    const canViewRequests = can(LMS.REQUEST_VIEW);
    const { news, isNewsLoading, pendingRequestCount } = useLmsDashboardHighlights({ canViewRequests });

    return (
        <div className="lms-dashboard">
            <div className="mb-4">
                <h1 style={{ color: PRIMARY, margin: 0, fontSize: '1.75rem' }}>{th('lmsDashboard.title')}</h1>
                <span className="text-color-secondary block mt-1">{th('lmsDashboard.subtitle')}</span>
            </div>

            <div className="grid">
                <div className="col-12 xl:col-4 flex">
                    <NewsHighlights news={news} isLoading={isNewsLoading} />
                </div>
                <div className="col-12 xl:col-8 flex">
                    <TrainingPerformance {...statsData} />
                </div>

                <div className="col-12 xl:col-8 flex">
                    <TrainingCalendar {...calendarData} />
                </div>
                <div className="col-12 xl:col-4 flex flex-column gap-3">
                    {canViewRequests && <RequestedTrainingsCard pendingCount={pendingRequestCount} />}
                    <QuickActions />
                </div>

                <div className="col-12">
                    <UpcomingTrainings {...upcomingData} />
                </div>
            </div>
        </div>
    );
};

export default LmsDashboardPage;
